import CPQEditorComponent from "./CPQEditorComponent";

export default CPQEditorComponent;
